// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GenerateGoogleOfflineOAuthUrlQueryVariables = Types.Exact<{
  state: Types.Scalars['String']['input'];
  redirectUri: Types.Scalars['Url']['input'];
}>;

export type GenerateGoogleOfflineOAuthUrlQuery = { __typename?: 'Query' } & Pick<
  Types.Query,
  'generateGoogleOfflineOAuthUrl'
>;

export const GenerateGoogleOfflineOAuthUrlDocument = /*#__PURE__*/ gql`
    query generateGoogleOfflineOAuthUrl($state: String!, $redirectUri: Url!) {
  generateGoogleOfflineOAuthUrl(state: $state, redirectUri: $redirectUri)
}
    `;

/**
 * __useGenerateGoogleOfflineOAuthUrlQuery__
 *
 * To run a query within a React component, call `useGenerateGoogleOfflineOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateGoogleOfflineOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateGoogleOfflineOAuthUrlQuery({
 *   variables: {
 *      state: // value for 'state'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useGenerateGoogleOfflineOAuthUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GenerateGoogleOfflineOAuthUrlQuery,
    GenerateGoogleOfflineOAuthUrlQueryVariables
  > &
    ({ variables: GenerateGoogleOfflineOAuthUrlQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GenerateGoogleOfflineOAuthUrlQuery, GenerateGoogleOfflineOAuthUrlQueryVariables>(
    GenerateGoogleOfflineOAuthUrlDocument,
    options,
  );
}
export function useGenerateGoogleOfflineOAuthUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GenerateGoogleOfflineOAuthUrlQuery,
    GenerateGoogleOfflineOAuthUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GenerateGoogleOfflineOAuthUrlQuery, GenerateGoogleOfflineOAuthUrlQueryVariables>(
    GenerateGoogleOfflineOAuthUrlDocument,
    options,
  );
}
// @ts-expect-error
export function useGenerateGoogleOfflineOAuthUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GenerateGoogleOfflineOAuthUrlQuery,
    GenerateGoogleOfflineOAuthUrlQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GenerateGoogleOfflineOAuthUrlQuery, GenerateGoogleOfflineOAuthUrlQueryVariables>;
export function useGenerateGoogleOfflineOAuthUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GenerateGoogleOfflineOAuthUrlQuery, GenerateGoogleOfflineOAuthUrlQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GenerateGoogleOfflineOAuthUrlQuery | undefined,
  GenerateGoogleOfflineOAuthUrlQueryVariables
>;
export function useGenerateGoogleOfflineOAuthUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GenerateGoogleOfflineOAuthUrlQuery, GenerateGoogleOfflineOAuthUrlQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GenerateGoogleOfflineOAuthUrlQuery, GenerateGoogleOfflineOAuthUrlQueryVariables>(
    GenerateGoogleOfflineOAuthUrlDocument,
    options,
  );
}
export type GenerateGoogleOfflineOAuthUrlQueryHookResult = ReturnType<typeof useGenerateGoogleOfflineOAuthUrlQuery>;
export type GenerateGoogleOfflineOAuthUrlLazyQueryHookResult = ReturnType<
  typeof useGenerateGoogleOfflineOAuthUrlLazyQuery
>;
export type GenerateGoogleOfflineOAuthUrlSuspenseQueryHookResult = ReturnType<
  typeof useGenerateGoogleOfflineOAuthUrlSuspenseQuery
>;
